import type { HelpFile } from '../../types/help'
import { RehireReviewDetailTestIds } from '../../../testids/RehireReviewDetailTestIds'

export const rehireReviewDetailHelp: HelpFile = {
  docPage: '/docs/admin/rehire-review',
  texts: {
    [RehireReviewDetailTestIds.rehireReviewDetail]:
      'Rehire review detail — inbound record matched against an existing identity, awaiting an admin decision.',
    [RehireReviewDetailTestIds.badgeDecidedByConnector]:
      'The connector pre-decided this rehire automatically based on its rules; the admin confirms or overrides.',
    [RehireReviewDetailTestIds.btnCancel]: null,
    [RehireReviewDetailTestIds.btnCreateNew]:
      'Reject the match and create a new identity for the inbound record — use when the connector matched the wrong person.',
    [RehireReviewDetailTestIds.btnReject]:
      'Reject this rehire — the inbound record is discarded and no identity is created or resurrected.',
    [RehireReviewDetailTestIds.btnResurrect]:
      'Re-activate the matched identity and apply the inbound attributes.',
    [RehireReviewDetailTestIds.btnSubmit]:
      'Submit the decision. Cannot be undone.',
    [RehireReviewDetailTestIds.cardTitleRehireReviewDiff]:
      'Field-by-field diff between the matched identity and the inbound record.',
    [RehireReviewDetailTestIds.colAttribute]: null,
    [RehireReviewDetailTestIds.colNewValue]:
      'Value from the inbound record — replaces the stored value on resurrection.',
    [RehireReviewDetailTestIds.colOldValue]:
      'Value currently stored on the matched identity.',
    [RehireReviewDetailTestIds.decisionInfoDecidedBy]:
      'Admin who recorded the decision and when it was made.',
    [RehireReviewDetailTestIds.entryDateError]:
      'Validation error for the new entry date — missing or in the past.',
    [RehireReviewDetailTestIds.inputNewEntryDate]:
      'Effective entry date for the resurrected or newly created identity.',
    [RehireReviewDetailTestIds.inputReason]:
      'Required reason for the decision — captured in the audit trail.',
    [RehireReviewDetailTestIds.reasonError]:
      'Validation error for the reason field — required text is missing.',
    [RehireReviewDetailTestIds.rehireReviewActionBar]:
      'Available actions for this rehire review: resurrect, reject, or create new.',
    [RehireReviewDetailTestIds.rehireReviewDecisionDialog]:
      'Captures the final decision, entry date, and reason before submission.',
    [RehireReviewDetailTestIds.rehireReviewDecisionInfo]:
      'Read-only summary of the decision recorded for this review.',
    [RehireReviewDetailTestIds.rehireReviewDiffCard]:
      'Side-by-side diff between the matched identity and the inbound record.',
    [RehireReviewDetailTestIds.rehireReviewIncomingCard]:
      'Inbound record received from the source system.',
    [RehireReviewDetailTestIds.rehireReviewMatchedCard]:
      'Existing identity the system matched as a possible rehire.',
    [RehireReviewDetailTestIds.rehireReviewReadonly]:
      'This review is closed; no further changes can be made.',
    [RehireReviewDetailTestIds.toastOpenIdentity]:
      'Open the matched identity that was just resurrected.',
    [RehireReviewDetailTestIds.toastOpenNewIdentity]:
      'Open the new identity created from the inbound record.',
    [RehireReviewDetailTestIds.toastOpenMyRequests]:
      'Open My Requests to see the access requests just filed for this rehire.',
    [RehireReviewDetailTestIds.rehireReviewPreviousAccessCard]:
      'Currently-active access profile assignments held by the matched (old) identity. Pick the ones you want to re-request for the rehired identity.',
    [RehireReviewDetailTestIds.cardTitlePreviousAccess]:
      'Header for the previous-access picker — shows whose prior access is listed.',
    [RehireReviewDetailTestIds.previousAccessSelectionCount]:
      'Running count of profiles currently selected for re-request.',
    [RehireReviewDetailTestIds.btnCreateAccessRequests]:
      'File one access request per selected profile against the rehired (or matched) identity. Each request runs through its own approval policy — the picker never grants access directly.',
  },
}
